import { render } from "./AddPackageForm.vue?vue&type=template&id=43c8a93a"
import script from "./AddPackageForm.vue?vue&type=script&lang=js"
export * from "./AddPackageForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__